module.exports = __webpack_public_path__ + "img/logo.b7cfc958.png";